import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';
import classnames from 'classnames';

export function SrpStickyHeaderTitle({ isMobile = false, seoData }) {
  const { make, model } = seoData;
  const generalTitle = model ? `Buy Your ${make} ${model} Online` : `Buy Your ${make} Online`;
  const title = !!make || !!model ? generalTitle : 'Buy Your Next Car Online';
  return (
    <Container>
      <div className="d-flex flex-column">
        <h1 className={classnames('mb-0', { 'heading-5': isMobile, 'heading-3': !isMobile })}>{title}</h1>
        {!isMobile && (
          <div className="mt-0_5 text-cool-gray-30 size-16">
            Shop the largest selection of cars from trusted brands that are available for delivery
          </div>
        )}
      </div>
    </Container>
  );
}

SrpStickyHeaderTitle.propTypes = {
  seoData: PropTypes.shape({
    make: PropTypes.string,
    model: PropTypes.string,
  }).isRequired,
  isMobile: PropTypes.bool,
};
